export const economicsOfEnterprisesAndOrganizationsConst = {
  path: "/single-programs/economics-of-enterprises-and-organizations",
  title: "ФАКУЛЬТЕТ БИЗНЕСА – ЭКОНОМИКА ПРЕДПРИЯТИЙ И ОРГАНИЗАЦИЙ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Экономика предприятий — ключ к эффективному управлению бизнесом</h2>
      <p>
        Что определяет успех современной компании? Точная экономическая стратегия, грамотное управление ресурсами и глубокий анализ всех
        бизнес-процессов. Эта программа формирует специалистов, способных принимать управленческие решения, повышать прибыльность
        предприятий и адаптировать бизнес к рыночным изменениям.
      </p>
      <p>
        Экономика предприятий и организаций — это универсальное образование, применимое в любой отрасли: от промышленности и IT до медицины
        и логистики.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Микро- и макроэкономику</li>
        <li>Финансовый и управленческий учёт</li>
        <li>Анализ и аудит деятельности компании</li>
        <li>Экономию ресурсов и производственных процессов</li>
        <li>Ценообразование и бюджетирование</li>
        <li>Управление инвестициями</li>
        <li>Бизнес-моделирование и оптимизация затрат</li>
        <li>Корпоративное планирование</li>
        <li>Международные стандарты и правовое регулирование</li>
      </ul>
      <p>
        Обучение построено на сочетании теории и практики: бизнес-кейсы, моделирование, работа с данными в Excel и BI-системах,
        экономические симуляции.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Экономист в коммерческой или государственной организации</li>
        <li>Финансовый аналитик</li>
        <li>Бизнес-консультант</li>
        <li>Планово-экономический специалист</li>
        <li>Менеджер по стратегическому развитию</li>
        <li>Специалист по инвестициям и проектному анализу</li>
        <li>Консультант по экономической безопасности</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€45,000 до €80,000 в год,</strong> в зависимости от специализации и сектора.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, открывающий двери в международные компании</li>
        <li>Преподаватели с опытом в крупном бизнесе и консалтинге</li>
        <li>Интерактивные форматы: практикумы, хакатоны, групповая работа</li>
        <li>Поддержка карьерного роста и стажировки</li>
        <li>Возможность учиться очно или дистанционно — с любого уголка мира</li>
        <li>Обучение на русском или английском языке</li>
      </ul>
      <p>Экономика — это не просто цифры, это инструмент управления будущим компании.</p>
      <h2>Как поступить?</h2>
      <p>
        Сделать первый шаг просто — приёмная комиссия проконсультирует по всем этапам, поможет с документами и выбором подходящей формы
        обучения.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Экономика предприятий — ключ к эффективному управлению бизнесом
    Что определяет успех современной компании? Точная экономическая стратегия, грамотное управление ресурсами и глубокий анализ всех бизнес-процессов. Эта программа формирует специалистов, способных принимать управленческие решения, повышать прибыльность предприятий и адаптировать бизнес к рыночным изменениям.
    Экономика предприятий и организаций — это универсальное образование, применимое в любой отрасли: от промышленности и IT до медицины и логистики.

    Что вы будете изучать?
    • Микро- и макроэкономику
    • Финансовый и управленческий учёт
    • Анализ и аудит деятельности компании
    • Экономию ресурсов и производственных процессов
    • Ценообразование и бюджетирование
    • Управление инвестициями
    • Бизнес-моделирование и оптимизация затрат
    • Корпоративное планирование
    • Международные стандарты и правовое регулирование
    Обучение построено на сочетании теории и практики: бизнес-кейсы, моделирование, работа с данными в Excel и BI-системах, экономические симуляции.

    Кем можно работать после окончания?
    • Экономист в коммерческой или государственной организации
    • Финансовый аналитик
    • Бизнес-консультант
    • Планово-экономический специалист
    • Менеджер по стратегическому развитию
    • Специалист по инвестициям и проектному анализу
    • Консультант по экономической безопасности

    Средний доход в Европе:
    от €45,000 до €80,000 в год, в зависимости от специализации и сектора.

    Почему выбирают нас?
    • Европейский диплом, открывающий двери в международные компании
    • Преподаватели с опытом в крупном бизнесе и консалтинге
    • Интерактивные форматы: практикумы, хакатоны, групповая работа
    • Поддержка карьерного роста и стажировки
    • Возможность учиться очно или дистанционно — с любого уголка мира
    • Обучение на русском или английском языке
    Экономика — это не просто цифры, это инструмент управления будущим компании.

    Как поступить?
    Сделать первый шаг просто — приёмная комиссия проконсультирует по всем этапам, поможет с документами и выбором подходящей формы обучения.
  `,
};
